module.exports = __webpack_public_path__ + "static/media/fill_circle.cc0ff649.png";